module.exports = __webpack_public_path__ + "static/kalashtar-89d24213481a37a04e801d94b750b28c.webp";